import axios from "axios";
import { BASE_URL } from "./type";

export function getUsers(query, dealer = 0, page) {
    return axios.get(BASE_URL + `user?role=${query}&dealer=${dealer}&page=${page}`);
}

export function getUser(id) {
    return axios.get(BASE_URL + `user/one?id=${id}`);
}

export function saveUser(data) {
    return axios.post(BASE_URL + `user`, { ...data });
}

export function deleteUser(id) {
    return axios.delete( BASE_URL + `user/${id}` );
}


export function updateAccount(id, data) {
    return axios.patch( BASE_URL + `user/${id}`, { ...data } );
}

export function updateDetails(data) {
    return axios.post( BASE_URL + `user/updateDetails`, { ...data } );
}

export function getDetails(id) {
    return axios.get( BASE_URL + `user/one?id=${id}` );
}

export function getDealers() {
    return axios.get( BASE_URL + `user/dealers` );
}

export function changeDealer(dealerId) {
    return axios.post( BASE_URL + `change-dealer`, { dealer: dealerId } );
}